<div class="consumer-asset-feedback" [class.consumer-asset-feedback--owner]="isOwnerPanel">
  <app-filter-panel
    [fields]="filterFields"
    [defaultExpanded]="false"
    (filterChange)="onFilterChange($event)"
    (clearFilters)="onClearFilters()"
  ></app-filter-panel>

  <app-table
    [columns]="columns"
    [data]="rows"
    [dropdownOpenRowIndex]="openDropdownRowIndex"
    [scrollable]="true"
    [scrollHeight]="'none'"
    [loading]="loading"
    [pagination]="pagination"
    [emptyMessage]="emptyMessage"
    [striped]="true"
    [bordered]="true"
    [hoverable]="true"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
  >
    <ng-template #feedbackCell let-row>
      <span
        *ngIf="hasFeedbackText(row); else emptyFeedback"
        class="feedback-text feedback-text--ellipsis feedback-text--clickable"
        (click)="openFeedbackModal(row, $event)"
      >{{ row.userFeedback }}</span>
      <ng-template #emptyFeedback>
        <span class="feedback-text feedback-text--empty">—</span>
      </ng-template>
    </ng-template>

    <ng-template #ratingCell let-row>
      <div
        class="rating-stars"
        *ngIf="ratingValue(row) > 0; else emptyRating"
        [attr.aria-label]="'Rating ' + ratingValue(row) + ' out of 5'"
      >
        <img
          *ngFor="let star of [1, 2, 3, 4, 5]"
          class="rating-stars__icon"
          [src]="
            isStarFilled(row, star)
              ? 'icons/dataset-ratings/star-filled.svg'
              : 'icons/dataset-ratings/star-outline.svg'
          "
          alt=""
          width="16"
          height="16"
        />
      </div>
      <ng-template #emptyRating>
        <span class="rating-value rating-value--empty">—</span>
      </ng-template>
    </ng-template>

    <ng-template #statusCell let-row>
      <span [ngClass]="statusChipClass(row.status)">{{ statusLabel(row.status) }}</span>
    </ng-template>

    <ng-template #actionCell let-row let-rowIndex="rowIndex">
      <div class="action-cell-wrapper" *ngIf="canShowAction(row); else noAction">
        <button
          type="button"
          class="action-btn"
          (click)="toggleActionDropdown($event, rowIndex)"
          [class.active]="isDropdownOpen(rowIndex)"
        >
          <span>Action</span>
        </button>
      </div>
      <ng-template #noAction>
        <span class="action-placeholder">—</span>
      </ng-template>
    </ng-template>
  </app-table>
</div>

<div
  *ngIf="dropdownPosition && openDropdownRow"
  class="action-dropdown-overlay"
  [style.top.px]="dropdownPosition.top"
  [style.left.px]="dropdownPosition.left"
  [style.right.px]="dropdownPosition.right"
  (click)="$event.stopPropagation()"
>
  <ul class="dropdown-list">
    <li class="dropdown-item">
      <button type="button" class="dropdown-link" (click)="handleAction('view', openDropdownRow)">
        View
      </button>
    </li>
    <li class="dropdown-item" *ngIf="canEditOrDelete(openDropdownRow)">
      <button type="button" class="dropdown-link" (click)="handleAction('edit', openDropdownRow)">
        Edit
      </button>
    </li>
    <li class="dropdown-item" *ngIf="canEditOrDelete(openDropdownRow)">
      <button
        type="button"
        class="dropdown-link dropdown-link--danger"
        (click)="handleAction('delete', openDropdownRow)"
      >
        Delete
      </button>
    </li>
  </ul>
</div>

<app-modal
  [(visible)]="showEditModal"
  [width]="'512px'"
  styleClass="custom-modal give-rating-dialog"
  maskStyleClass="give-rating-mask"
  appendTo="body"
  [showHeader]="false"
  [showFooter]="false"
  (visibleChange)="onEditModalVisibleChange($event)"
>
  <div class="give-rating">
    <div class="give-rating--header">
      <div class="give-rating--heading">
        <h2 class="give-rating--title">Edit Feedback</h2>
        <p class="give-rating--subtitle">Update how this asset performed for your use case.</p>
      </div>
      <button type="button" class="give-rating--close" aria-label="Close" (click)="closeEditModal()">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path
            d="M5 5l10 10M15 5L5 15"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      </button>
    </div>

    <div class="give-rating--body">
      <div class="give-rating--field">
        <label class="give-rating--label" id="edit-rating-stars-label">
          Rating <span class="give-rating--required">*</span>
        </label>
        <div
          class="give-rating--stars"
          role="radiogroup"
          aria-labelledby="edit-rating-stars-label"
          (mouseleave)="hoveredRating = 0"
        >
          <button
            *ngFor="let star of [1, 2, 3, 4, 5]"
            type="button"
            class="give-rating--star"
            role="radio"
            [attr.aria-checked]="selectedRating === star"
            [attr.aria-label]="star + ' star'"
            (mouseenter)="hoveredRating = star"
            (click)="selectRating(star)"
          >
            <img
              [src]="displayedRating >= star ? 'icons/dataset-ratings/star-filled.svg' : 'icons/dataset-ratings/star-outline.svg'"
              alt=""
              width="40"
              height="40"
            />
          </button>
        </div>
        <p class="give-rating--error" *ngIf="showRatingRequiredError">Please select a rating</p>
      </div>

      <div class="give-rating--field">
        <label class="give-rating--label" for="edit-rating-feedback">Feedback</label>
        <div class="give-rating--textarea-wrap">
          <textarea
            id="edit-rating-feedback"
            class="give-rating--textarea"
            rows="5"
            maxlength="200"
            placeholder="Enter your feedback..."
            [(ngModel)]="ratingFeedback"
          ></textarea>
          <span class="give-rating--counter">{{ ratingFeedback.length }}/200</span>
        </div>
      </div>
    </div>

    <div class="give-rating--actions">
      <button type="button" class="give-rating--cancel" (click)="closeEditModal()">Cancel</button>
      <button
        type="button"
        class="give-rating--submit"
        [disabled]="isSubmittingEdit || !canSaveEdit"
        (click)="submitEdit()"
      >
        Save
      </button>
    </div>
  </div>
</app-modal>

<app-modal
  [(visible)]="showFeedbackModal"
  header="User Feedback"
  [width]="'512px'"
  styleClass="custom-modal feedback-view-dialog"
  maskStyleClass="feedback-view-mask"
  appendTo="body"
  [showFooter]="false"
  (visibleChange)="onFeedbackModalVisibleChange($event)"
>
  <div class="give-rating give-rating--view" *ngIf="feedbackModalRow as row">
    <div class="feedback-from">
      <span class="feedback-from__avatar" aria-hidden="true">{{ feedbackAuthorInitials(row) }}</span>
      <div class="feedback-from__meta">
        <span class="feedback-from__label">Feedback from</span>
        <span class="feedback-from__name">{{ feedbackAuthorName(row) }}</span>
        <span class="feedback-from__org" *ngIf="feedbackAuthorOrg(row)">{{ feedbackAuthorOrg(row) }}</span>
      </div>
    </div>

    <div class="give-rating--field">
      <label class="give-rating--label" id="view-feedback-stars-label">Rating</label>
      <div
        class="give-rating--stars"
        role="img"
        [attr.aria-label]="'Rating ' + feedbackModalRating + ' out of 5'"
        aria-labelledby="view-feedback-stars-label"
      >
        <span *ngFor="let star of [1, 2, 3, 4, 5]" class="give-rating--star" aria-hidden="true">
          <img
            [src]="
              feedbackModalRating >= star
                ? 'icons/dataset-ratings/star-filled.svg'
                : 'icons/dataset-ratings/star-outline.svg'
            "
            alt=""
            width="40"
            height="40"
          />
        </span>
      </div>
    </div>

    <div class="give-rating--field">
      <label class="give-rating--label">Feedback</label>
      <p
        class="give-rating--feedback-text"
        [class.give-rating--feedback-text-empty]="!hasFeedbackText(row)"
      >
        {{ hasFeedbackText(row) ? row.userFeedback : 'No written feedback' }}
      </p>
    </div>

    <div class="give-rating--field" *ngIf="row.status === 'rejected' && row.rejectionComment">
      <label class="give-rating--label">Comment for rejection</label>
      <p class="give-rating--feedback-text">{{ row.rejectionComment }}</p>
    </div>
  </div>
</app-modal>

<app-confirmation-dialog
  [(visible)]="showDeleteConfirm"
  type="delete"
  title="Delete Feedback"
  [message]="getDeleteMessage()"
  confirmLabel="Delete"
  cancelLabel="Cancel"
  themeColor="red"
  [loading]="deleteLoading"
  (onConfirm)="onDeleteConfirm()"
  (onCancel)="onDeleteCancel()"
  (onClose)="onDeleteCancel()"
></app-confirmation-dialog>
